const guid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  }
  return s4() + s4() + s4() + s4()
}


export const localCache = {
  typeDefault: {
    viewBy: {
      __typename: 'viewBy',
      id: guid(),
      name: 'products'
    },
    sortBy: {
      name: 'createdAt',
      order: 'DESC',
      __typename: 'sortBy'
    },
    dragItem: {
      id: guid(),
      name: '',
      defnName: '',
      label: '',
      dragType: '',
      dragFrom: '',
      __typename: 'drag'
    },
    cardView: {
      id: guid(),
      __typename: 'cardView',
      all: true,
      product_info: true,
      material: true,
      color: true,
      style: true,
      hardware: true,
      tags: true
    },
    seasonalSearch: {
      text: '',
      __typename: 'seasonalsearch'
    },
    filter: {
      id: '1',
      color: [],
      hardware: [],
      material: [],
      sketch: [],
      tag: [],
      active: {
        id: '1',
        status: false,
        __typename: 'active'
      },
      inactive: {
        id: '1',
        status: false,
        __typename: 'inactive'
      },
      customAttributes: [],
      __typename: 'filterData'
    },
    siteLibrary: {
      id: 1,
      status: 0,
      listView: false,
      searchText: '',
      __typename: 'siteLibrary'
    },
    sortByLibraryTable: {
      id: 1,
      name: 'createdAt',
      order: 'DESC',
      __typename: 'sortByLibraryTable'
    },
    libraryTablePagination: {
      id: 1,
      first: 50,
      skip: 0,
      __typename: 'libraryTablePagination'
    },
    tagsLibraryConfiguration: {
      id: 1,
      name: 'createdAt',
      order: 'DESC',
      first: 50,
      skip: 0,
      siteView: false,
      searchText: '',
      __typename: 'tagsLibraryConfiguration'
    },
    selectedSeason: {
      id: guid(),
      season: '',
      category1: '',
      category2: '',
      __typename: 'selectedSeason'
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/apollo/defaults/Defaults.ts